export const pageIdSym = Symbol('pageId')
export const contextIdSymbol = Symbol('contextId')
export const PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol')
export const CssFetcherSymbol = Symbol('CssFetcher')
export const PageResourceFetcherSymbol = Symbol('PageResourceFetcher')
export const PageFeatureLoaderSym = Symbol('PageFeatureLoader')
export const PageTransitionsCompletedSymbol = Symbol('PageTransitionsCompleted')
export const PageStructureJsonSymbol = Symbol('PageStructure')
export const PagePropsJsonSymbol = Symbol('PageProps')
export const PageProviderSymbol = Symbol('PageProvider')
export const PageInitializerSymbol = Symbol('PageInitializer')
